var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07 3.93a.54.54 0 0 0-.53.55v.29c0 .3.24.55.53.55h12.2c.28 0 .52-.25.52-.55v-.29c0-.3-.24-.55-.52-.55h-2.15a.95.95 0 0 1-.91-.76l-.12-.51a1.47 1.47 0 0 0-1.4-1.16H7.65c-.65 0-1.24.46-1.4 1.12l-.12.55a.95.95 0 0 1-.92.76H3.07Zm1.09 10.42a356.8 356.8 0 0 1-.62-7.23.57.57 0 0 1 .13-.42c.1-.11.24-.18.39-.18h10.2c.16 0 .3.07.4.18.1.12.14.26.13.42l-.03.48c-.1 1.32-.4 5-.59 6.75-.13 1.28-.96 2.1-2.16 2.12a121.37 121.37 0 0 1-5.65 0c-1.24-.02-2.06-.81-2.2-2.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashmedium);
export default __webpack_public_path__ + "static/media/trash.medium.3ce1132d50ff47572e3ac563b3523628.svg";
export { ForwardRef as ReactComponent };